/* eslint-disable no-param-reassign */
import Vue from 'vue';
import Vuex, { ActionTree, StoreOptions } from 'vuex';
import { RootState } from './types';
import Auth from './modules/auth';
import Loader from './modules/loader';
import Config from './modules/config';

Vue.use(Vuex);

const initialState: RootState = {
  error: null,
};

const actions: ActionTree<RootState, RootState> = {
  clearError({ commit, getters }) {
    if (getters.hasError) {
      commit('CLEAR_ERROR');
    }
  },
};

const getters = {
  hasError: (state: RootState) => state.error !== null,
};

const mutations = {
  CLEAR_ERROR(s: RootState) {
    s.error = null;
  },
  SET_ERROR(s: RootState, error: string | string[] | null) {
    s.error = error;
  },
};

const store: StoreOptions<RootState> = {
  /**
   * Do not enable strict mode when deploying for production!
   * Strict mode runs a synchronous deep watcher on the state tree for detecting inappropriate
   * mutations, and it can be quite expensive when you make large amount of mutations to the
   * state. Make sure to turn it off in production to avoid the performance cost.
   */
  strict: process.env.NODE_ENV !== 'production',

  state: initialState,
  actions,
  mutations,
  getters,
  modules: {
    Auth,
    Loader,
    Config,
  },
};

export default new Vuex.Store<RootState>(store);
